let testimonials = {
    init: function () {
        jQuery('.c-slider-testimonials').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            focusOnSelect: false,
            accessibility: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 639,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        dots: false,
                    }
                },
                
            ]
        });
    }
}